import React, { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const endOfMonth = () => {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth() + 1, 1, 0, 0, 0);
};

const remaining = () => Math.max(0, endOfMonth() - new Date());

const UNITS = [
  { key: "days", label: "giorni", div: 86400000 },
  { key: "hours", label: "ore", div: 3600000, mod: 24 },
  { key: "minutes", label: "minuti", div: 60000, mod: 60 },
  { key: "seconds", label: "secondi", div: 1000, mod: 60 },
];

export const OfferCountdown = () => {
  const [ms, setMs] = useState(remaining);
  useEffect(() => {
    const id = setInterval(() => setMs(remaining()), 1000);
    return () => clearInterval(id);
  }, []);
  const deadline = new Date(endOfMonth() - 1).toLocaleDateString("it-IT", { day: "numeric", month: "long" });
  return (
    <div className="mt-6 rounded-2xl bg-black/20 border border-white/20 p-4 sm:p-5" data-testid="offer-countdown">
      <p className="flex items-center gap-2 text-sm font-bold uppercase tracking-widest">
        <Timer size={18} /> L'offerta scade il {deadline}
      </p>
      <div className="mt-3 grid grid-cols-4 gap-2 sm:gap-3 max-w-md">
        {UNITS.map((u) => {
          const v = Math.floor(ms / u.div) % (u.mod || Infinity);
          return (
            <div key={u.key} className="rounded-xl bg-white text-[var(--sc-emerald)] text-center py-2 sm:py-3 shadow" data-testid={`offer-countdown-${u.key}`}>
              <span className="block text-2xl sm:text-3xl font-extrabold tabular-nums" style={{ fontFamily: "Outfit" }}>{String(v).padStart(2, "0")}</span>
              <span className="block text-[11px] sm:text-xs font-semibold text-slate-600">{u.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
